export const COMPOUND_COLORS = {
  SOFT: '#e10600',
  MEDIUM: '#f7f00c',
  HARD: '#f2f2f2',
  INTERMEDIATE: '#2bbf4f',
  WET: '#3b82f6',
  UNKNOWN: '#6b7280',
};

export const compoundColor = (c) => COMPOUND_COLORS[c?.toUpperCase()] || COMPOUND_COLORS.UNKNOWN;

const DRIVER_PALETTE = [
  '#e10600', '#f7f00c', '#2bbf4f', '#3b82f6', '#a855f7',
  '#f97316', '#22d3ee', '#ec4899', '#84cc16', '#14b8a6',
  '#f59e0b', '#8b5cf6', '#06b6d4', '#d946ef', '#10b981',
  '#ef4444', '#eab308', '#0ea5e9', '#c026d3', '#a3e635',
];

export const driverColor = (driver, drivers) => {
  const idx = drivers.indexOf(driver);
  if (idx < 0) return COMPOUND_COLORS.UNKNOWN;
  return DRIVER_PALETTE[idx % DRIVER_PALETTE.length];
};
